import { h } from 'preact';
import { useState } from 'preact/hooks';
import { CreateNewList } from './create-new-list';
import { AddToList } from './add-to-list';
import { addToWishlist, createList, refreshLists, removeFromWishlist } from '.';
import { t } from '../theme/locales';
const hasVariantInList = (list, selectedVariantId)=>{
    if (!selectedVariantId) return false;
    return !!list.listcontents.find((item)=>item.epi === selectedVariantId);
};
const buildSelectedByLid = (lists, selectedVariantId)=>{
    return lists.reduce((acc, list)=>{
        acc[list.lid] = hasVariantInList(list, selectedVariantId);
        return acc;
    }, {});
};
export const Content = ({ selectedVariantId , productId , variantTitle , productTitle , productUrl , size , image , isInWishlist , wishlists , onWishlistChange , product , action , wishlistName  })=>{
    var _formState_wishlists;
    const [formState, setFormState] = useState({
        selectedVariantId,
        productId,
        variantTitle,
        productTitle,
        productUrl,
        size,
        image,
        isCreating: false,
        wishlistName,
        wishlistLink: '/pages/wishlist',
        newWishlistName: '',
        newWishlistLink: '',
        creatingButtonDisabled: true,
        creatingButtonVisible: false,
        submitted: false,
        loading: false,
        isInWishlist: isInWishlist || false,
        wishlists: wishlists || [],
        selectedByLid: buildSelectedByLid(wishlists || [], selectedVariantId),
        product: product || null,
        action
    });
    const handleToggleList = (lid, checked)=>{
        setFormState((prev)=>({
                ...prev,
                selectedByLid: {
                    ...prev.selectedByLid,
                    [lid]: checked
                }
            }));
    };
    const handleSubmitWishlistChanges = async (e)=>{
        e.preventDefault();
        if (!window._swat) {
            console.error('Swym API not initialized');
            return;
        }
        if (!formState.selectedVariantId || !formState.productId || !formState.productUrl) {
            console.error('Missing product information for wishlist update');
            return;
        }
        const swat = window._swat;
        const name = formState.newWishlistName.trim();
        let act = 'added';
        let listName = formState.wishlistName;
        let hasError = false;
        try {
            var _formState_product;
            setFormState((prev)=>({
                    ...prev,
                    loading: true
                }));
            const wishlistProduct = {
                epi: formState.selectedVariantId,
                empi: formState.productId,
                du: formState.productUrl,
                cprops: {
                    images: ((_formState_product = formState.product) === null || _formState_product === void 0 ? void 0 : _formState_product.images) || []
                }
            };
            if (name) {
                const newList = await createList(swat, name, false);
                const newLid = newList === null || newList === void 0 ? void 0 : newList.lid;
                if (newLid) {
                    await addToWishlist(newLid, swat, wishlistProduct);
                    act = 'added';
                    listName = name;
                }
            }
            for (const list of formState.wishlists){
                const desiredChecked = !!formState.selectedByLid[list.lid];
                const currentlyChecked = hasVariantInList(list, formState.selectedVariantId);
                if (desiredChecked && !currentlyChecked) {
                    await addToWishlist(list.lid, swat, wishlistProduct);
                    act = 'added';
                    listName = list.lname || listName;
                }
                if (!desiredChecked && currentlyChecked) {
                    await removeFromWishlist(list.lid, swat, wishlistProduct);
                    act = 'removed';
                    listName = list.lname || listName;
                }
            }
        } catch (error) {
            hasError = true;
            console.error('Failed to update wishlists:', error);
        } finally{
            const lists = await refreshLists(swat);
            const selectedByLid = buildSelectedByLid(lists, formState.selectedVariantId);
            const variantInAnyList = lists.some((list)=>hasVariantInList(list, formState.selectedVariantId));
            setFormState((prev)=>({
                    ...prev,
                    loading: false,
                    wishlists: lists,
                    selectedByLid,
                    newWishlistName: '',
                    creatingButtonVisible: false,
                    submitted: true,
                    action: act,
                    wishlistName: listName,
                    isInWishlist: variantInAnyList
                }));
            onWishlistChange === null || onWishlistChange === void 0 ? void 0 : onWishlistChange(variantInAnyList);
            if (!hasError) {
                window.dispatchEvent(new CustomEvent('modal:close', {
                    detail: {
                        id: 'wishlist-modal'
                    }
                }));
            }
        }
    };
    const handleNameChange = (value)=>{
        setFormState((prev)=>({
                ...prev,
                newWishlistName: value,
                creatingButtonVisible: !!value.trim()
            }));
    };
    return h('div', {
        className: 'wishlist__content outer',
        'data-testid': 'wishlist-modal'
    }, [
        h('div', {
            className: 'wishlist__item'
        }, [
            h('picture', {
                className: 'wishlist__item__image'
            }, [
                h('img', {
                    src: image || '',
                    alt: productTitle || t('wishlist.product_image_alt')
                })
            ]),
            h('dl', {
                className: 'wishlist__item__details'
            }, [
                h('dd', {
                    className: 'wishlist__item__details__product'
                }, productTitle || t('wishlist.product_title_fallback')),
                formState.wishlists && h('dt', {
                    className: 'wishlist__item__details__info'
                }, [
                    h('span', {}, formState.action === 'removed' ? t('wishlist.item_action_removed') : t('wishlist.item_action_added')),
                    h('a', {
                        href: formState.wishlistLink
                    }, formState.wishlistName)
                ])
            ])
        ], action === 'added' && formState.wishlists && ((_formState_wishlists = formState.wishlists) === null || _formState_wishlists === void 0 ? void 0 : _formState_wishlists.length) > 0 && h('div', {
            className: 'wishlist__content'
        }, [
            h('p', {
                className: 'wishlist__content__title'
            }, t('wishlist.add_this_item_to_list')),
            h(AddToList, {
                name: formState.wishlistName,
                onNameChange: handleNameChange,
                onToggle: handleToggleList,
                disabled: formState.loading,
                wishlists: formState.wishlists || [],
                selectedByLid: formState.selectedByLid,
                loading: formState.loading
            }),
            h(CreateNewList, {
                name: formState.newWishlistName,
                onNameChange: handleNameChange,
                onSubmit: handleSubmitWishlistChanges,
                disabled: formState.loading
            })
        ]))
    ]);
};
